let titleOp = {
  title: {
    text: '暂未提供'
  }
}
export function ActiveTrendEchartOp ({ v, data = [] }) {
  let options = {
    color: ['#3198f7'],
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b} : {c}%'
    },
    // legend: {
    //   data: ['Show', 'Click', 'Visit', 'Inquiry', 'Order']
    // },
    series: [
      {
        top: 0,
        bottom: 0,
        width: '80%',
        minSize: '50%',
        name: 'Expected',
        type: 'funnel',
        left: 10,
        gap: 4,
        max: 100,
        label: {
          show: true,
          position: 'rightTop',
          color: 'rgba(255, 255, 255,1)',
          formatter: function (d, c, a) {
            let cList = ['c', 'c1', 'c2', '']
            // let textList = [...data.name]
            // return `{${cList[d.dataIndex]}|}  {n|${textList[d.dataIndex]}}\n{percent|${d.data.percent}%}`
            return d.data.percent + '%'
          },
          rich: {
            // c: {
            //   width: v.fontSizeRem(0.45),
            //   height: v.fontSizeRem(0.45),
            //   backgroundColor: 'rgba(0, 114, 255, 1)',
            //   borderRadius: 50,
            //   verticalAlign: 'top'
            // },
            // c1: {
            //   width: v.fontSizeRem(0.45),
            //   height: v.fontSizeRem(0.45),
            //   backgroundColor: 'rgba(255, 218, 58, 1)',
            //   borderRadius: 50,
            //   verticalAlign: 'top'
            // },
            // c2: {
            //   width: v.fontSizeRem(0.45),
            //   height: v.fontSizeRem(0.45),
            //   backgroundColor: 'rgba(255, 95, 165, 1)',
            //   borderRadius: 50,
            //   verticalAlign: 'top'
            // },
            // percent: {
            //   fontSize: v.fontSizeRem(0.8),
            //   padding: [2, 0, 0, -10],
            //   alias: 'left'
            // },
            // n: {
            //   fontSize: v.fontSizeRem(0.65)
            // }
          }
        },
        labelLine: {
          show: false
        },
        itemStyle: {
          // opacity: 0.7
        },
        emphasis: {
          disable: false
        },
        data: [
          // { value: 60, name: '新增用户' },
          // { value: 40, name: '设备首次联网用户' },
          // { value: 20, name: '主页活跃用户' },
          // { value: 80, name: '登录用户' },
          // { value: 100, name: '登录新注册用户' }
          ...data
        ]
      },
      {
        top: 0,
        bottom: 0,
        left: 10,
        width: '80%',
        name: 'Actual',
        type: 'funnel',
        minSize: '50%',
        gap: 4,
        max: 100,
        label: {
          position: 'inside',
          formatter: function (d) {
            return `${d.data.name}\n${d.data.val}`
          },
          color: '#fff'
        },
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 0
        },
        emphasis: {
          disable: false
        },
        data: [...data.map(item => { let { label, ...arg } = item; return { ...arg } })],
        // data: [
        //   // { value: 60, name: '新增用户' },
        //   // { value: 40, name: '设备首次联网用户' },
        //   // { value: 20, name: '主页活跃用户' },
        //   // { value: 80, name: '登录用户' },
        //   // { value: 100, name: '登录新注册用户' }
        //   ...data
        // ],
        // Ensure outer shape will not be over inner shape when hover.
        z: 100
      }
    ]
  }
  return options
}
export function NetworkActivationAnalysisEchartOp ({ v, data }) {
  let options = {
    tooltip: {
      trigger: 'axis'
    },
    grid: {
      left: '0%',
      top: '20%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    legend: {
      data: ['测', '试'],
      textStyle: {
        color: 'white'
      },
      itemWidth: v.fontSizeRem(0.4)
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: [...data.date],
      axisLabel: {
        color: 'rgba(255, 255, 255, 1)'
      }
    },
    yAxis: [
      {
        type: 'value',
        splitNumber: 5,
        axisLabel: {
          color: 'rgba(255, 255, 255, 1)'
        },
        splitLine: {
          show: false
        }
      }
    ],

    series: [
      {
        data: [...data.data],
        type: 'line',
        areaStyle: {
          color: 'rgba(23, 36, 94,0.8)'
        },
        lineStyle: {
          color: 'rgba(10, 61, 175,1)'
        },
        symbol: 'none',
        yAxisIndex: 0
      }
      // {
      //   name: '试',
      //   data: [120, 332, 401, 34, 290, 130, 120],
      //   type: 'line',
      //   areaStyle: {
      //     color: 'rgba(76, 61, 44,0.8)'
      //   },
      //   lineStyle: {
      //     color: 'rgba(146, 139, 70,1)'
      //   },
      //   symbol: 'none',
      //   yAxisIndex: 0
      // }
    ]
  }
  return options
}

export function ActiveProportionEachSystemVersionEchartOp ({ v, data = [] }) {
  let options = {
    color: ['#1d5eeb', '#65d5d1', '#edcd4b', '#e26032', '#312d6f', '#866dbc'],
    tooltip: {
      trigger: 'item'
    },
    legend: {
      icon: 'circle',
      bottom: 30,
      data: data.map(item => item.name),
      textStyle: {
        color: 'rgba(255, 255, 255, 0.8)'
      }
    },
    series: [
      {
        top: '-25%',
        name: '访问来源',
        type: 'pie',
        radius: ['0%', '70%'],
        avoidLabelOverlap: true,
        label: {
          show: true,
          position: 'inside',
          color: 'rgba(255, 255, 255, 1)'
        },
        emphasis: {
          label: {
            show: false,
            fontSize: '30',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          // { value: 335, name: 'IOS' },
          // { value: 310, name: 'PC' },
          // { value: 135, name: '安卓' }
          ...(data ?? [])
        ]
      }
    ]
  }
  return options
}

export function Liandongping1EchartOp ({ v }) {
  let options = {
    color: [],
    legend: {
      show: false,
      icon: 'circle',
      data: ['投屏', '家庭看护', '视频通话', '影视', '遥控', '智慧眼', '联动应用'],
      textStyle: {
        color: 'rgba(255, 255, 255, 0.8)'
      }
    },
    grid: {
      left: '0%',
      top: '0%',
      right: '0%',
      bottom: '0%',
      containLabel: true
    },
    xAxis: [{
      type: 'value',
      show: false,
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      }
    }],
    yAxis: [{
      type: 'category',
      data: ['投屏', '家庭看护', '视频通话', '影视', '遥控', '智慧眼', '联动应用'],
      axisLabel: {
        color: 'rgba(255, 255, 255, 0.8)'
        // fontSize: v.fontSizeRem(0.75)
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      }
    }],
    series: [{
      type: 'bar',
      color: {
        type: 'linear',
        x: 1,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [{
          offset: 0, color: '#01C7E5' // 0% 处的颜色
        }, {
          offset: 1, color: '#042CF3' // 100% 处的颜色
        }]
      },
      data: [48292, 12829, 5029, 28299, 38292, 2899, 1922],
      barWidth: v.fontSizeRem(0.8),
      showBackground: true,
      backgroundStyle: {
        color: 'rgba(255, 255, 255, 0.2)'
      },
      label: {
        position: ['50%', '20%'],
        show: true,
        // textBorderColor: '#333',
        // textBorderWidth: 2,
        color: 'rgba(255,255,255,1)'

      }
    }]
  }
  return options
}

export function Liandongping2EchartOp ({ v }) {
  let options = {

    grid: {
      left: '0%',
      top: '20%',
      right: '5%',
      bottom: '0%',
      containLabel: true
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['视频通话', '家庭用户', '投屏用户'],
      icon: 'circle',
      textStyle: {
        color: 'white'
      },
      itemWidth: v.fontSizeRem(0.4),
      right: 0
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: ['03-04', '03-05', '03-06', '03-07', '03-08', '03-09', '03-10'],
      axisLabel: {
        color: 'rgba(255, 255, 255, 1)',
        rotate: 25
      }
    },
    yAxis: [
      {
        type: 'value',
        splitNumber: 5,
        axisLabel: {
          color: 'rgba(255, 255, 255, 1)'
        },
        splitLine: {
          show: false
        }
      }

    ],

    series: [
      {
        name: '视频通话',
        data: [4392, 4923, 5290, 5028, 4920, 4982, 4729, 5029],
        type: 'line',
        areaStyle: {
          color: 'rgba(23, 36, 94,0.8)'
        },
        lineStyle: {
          color: 'rgba(10, 61, 175,1)'
        },
        symbol: 'none',
        z: 3,
        yAxisIndex: 0
      },
      {
        name: '家庭用户',
        data: [10292, 12273, 13829, 13929, 12930, 12923, 10282, 12829],
        type: 'line',
        areaStyle: {
          color: 'rgba(276, 61, 44,0.8)'
        },
        lineStyle: {
          color: 'rgba(146, 139, 70,1)'
        },
        symbol: 'none',
        z: 2,
        yAxisIndex: 0
      },
      {
        name: '投屏用户',
        data: [47282, 49930, 49283, 49200, 44030, 49202, 47628, 48292],
        type: 'line',
        areaStyle: {
          color: 'rgba(6, 161, 144,0.8)'
        },
        lineStyle: {
          color: 'rgba(246, 239, 70,1)'
        },
        symbol: 'none',
        z: 1,
        yAxisIndex: 0
      }
    ]
  }
  return options
}
